import { Button } from '@/components/shadcn/ui/button';
import React from 'react';
import { Dialog, DialogContent, DialogFooter, DialogHeader, DialogOverlay, DialogTitle, DialogTrigger } from '@/components/shadcn/ui/dialog';
import { Form, FormControl, FormField, FormItem, FormLabel, FormMessage } from '@/components/shadcn/ui/form';
import { Input } from '@/components/shadcn/ui/input';
import { Textarea } from '@/components/shadcn/ui/textarea';
import { useIndicatorsContext } from '@/context/IndicatorContex';
import useComments from '@/hook/useComments';
import CustomInputPercentageMask from '@/utils/customInputPercentageMask';
import CustomInputPhoneMask from '@/utils/customInputPhoneMask';
import { zodResolver } from '@hookform/resolvers/zod';
import { PlusIcon, BoxIcon, Trash2Icon } from 'lucide-react';
import { ChangeEvent, FormEvent, useEffect } from 'react';
import { useForm } from 'react-hook-form';
import { z } from 'zod';

const schema = z.object({
  id: z.number(),
  name: z.string(),
  email: z.string(),
  phone: z.string(),
  commission: z.string()
});

type DeleteDialogProps = {
    handleDelete: () => void;
}
// eslint-disable-next-line
const CommentDeleteDialog:React.FC<DeleteDialogProps> = ({handleDelete}) => {
  const {deleteOpen, setDeleteOpen} = useComments();
  const form = useForm({
    resolver: zodResolver(schema),
  });

  return (
    <Dialog open = {deleteOpen} onOpenChange={()=>{
      setDeleteOpen(!deleteOpen);
    }}>
      <DialogTrigger >
        <div className=''>
          <button title='Apagar'>
            <Trash2Icon size={26} className='bg-indigo-50 hover:bg-indigo-200 rounded-md p-1' />
          </button>
        </div>
      </DialogTrigger> 
      <DialogContent className='w-1/4 h-auto'> 
        <DialogHeader>
          <DialogTitle>
            <div className='flex items-center gap-2'>
              <Trash2Icon  size={22} />
                Deletar Comentário
            </div>
          </DialogTitle>
          <div className='grid flex-1 gap-2'>
            <h3>Deseja deletar este comentário?</h3>
          </div>
        </DialogHeader>
        <DialogFooter>
          <Button className='bg-indigo-700' onClick={()=>{
            setDeleteOpen(!deleteOpen);
            handleDelete();
          }}>{'Sim'}</Button>
          <Button className='bg-indigo-700' onClick={()=>{
            setDeleteOpen(!deleteOpen);
          }}>{'Não'}</Button>
          
        </DialogFooter>  
      </DialogContent> 
    </Dialog>
  );
};

export default CommentDeleteDialog;
